import { Flex, Text, Skeleton } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { AiOutlineArrowUp, AiOutlineArrowDown } from "react-icons/ai";

interface DashboardCardProps {
  label: string;
  valuePercent: number | null;
  icon: any;
  value: any;
  bg: string;
  positive: boolean;
  isLoading?: boolean;
  right?: any;
}

function DashboardCard({
  label,
  icon,
  bg,
  valuePercent,
  value,
  positive,
  isLoading,
  right,
}: DashboardCardProps) {
  return (
    <Flex
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      flexDir="column"
      bg="white"
      rounded="16px"
      p="16px"
    >
      <Flex>
        <Flex flex={1} mt="10px">
          {!isLoading ? (
            <Flex
              w="50px"
              h="50px"
              rounded="50%"
              justifyContent="center"
              alignItems="center"
              bg={bg}
            >
              {icon}
            </Flex>
          ) : null}

          {isLoading ? (
            <Skeleton w="50px" h="50px" rounded="50%" justifyContent="center" />
          ) : null}

          {right ? (
            <Flex flex={1} justifyContent="flex-end">
              {right}
            </Flex>
          ) : null}
        </Flex>

        {valuePercent !== null ? (
          <Flex flex={1} flexDir="column">
            <Flex justifyContent="flex-end">
              <Flex>
                {positive ? (
                  <AiOutlineArrowUp fontSize="20px" color={colors.green1000} />
                ) : (
                  <AiOutlineArrowDown fontSize="20px" color={colors.red} />
                )}
              </Flex>
              <Text
                textAlign="right"
                color={positive ? colors.green1000 : colors.red}
                fontSize="16px"
              >
                {valuePercent}%
              </Text>
            </Flex>
            <Text color="gray.600" textAlign="right" fontSize="12px">
              Neste período
            </Text>
          </Flex>
        ) : null}
      </Flex>
      <Flex flexDir="column" mt="4px">
        <Text fontSize="14px">
          {!isLoading ? label : null}
          {isLoading ? <Skeleton w="75px" h="10px" mb="6px" /> : null}
        </Text>
        <Text color="gray.600" fontSize="22px" fontWeight="bold">
          {!isLoading ? value : null}
          {isLoading ? <Skeleton w="55px" h="40px" /> : null}
        </Text>
      </Flex>
    </Flex>
  );
}

export default DashboardCard;
